// Client-portal specific: Stripe key mapping by subsidiary and gateway
import {
  STRIPE_CERTN_CANADA_PUBLISHABLE_KEY,
  STRIPE_CERTN_CANADA_PREPAY_PUBLISHABLE_KEY,
  STRIPE_CERTN_UK_PUBLISHABLE_KEY,
  STRIPE_CERTN_UK_PREPAY_PUBLISHABLE_KEY,
  STRIPE_CERTN_USA_PUBLISHABLE_KEY,
  STRIPE_CERTN_USA_PREPAY_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_PREPAY_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_CONSUMER_PUBLISHABLE_KEY,
} from "../../../constants";
import { Subsidiary } from "../../types";

// Re-export shared constants from @certn/utils
export { fonts, options } from "@certn/utils";

export const mapSubsidiaryToStripeKey: Record<Subsidiary, string> = {
  CERTN_CANADA: STRIPE_CERTN_CANADA_PUBLISHABLE_KEY,
  CERTN_USA: STRIPE_CERTN_USA_PUBLISHABLE_KEY,
  CREDENCE: STRIPE_CERTN_UK_PUBLISHABLE_KEY,
  INTERCHECK: STRIPE_INTERCHECK_PUBLISHABLE_KEY,
};

// Map StripeGateway values (from backend) to publishable keys
// This mapping handles all gateways including prepay accounts
export const mapGatewayToStripeKey: Record<string, string> = {
  STRIPE_CERTN_CANADA: STRIPE_CERTN_CANADA_PUBLISHABLE_KEY,
  STRIPE_CERTN_CANADA_PREPAY: STRIPE_CERTN_CANADA_PREPAY_PUBLISHABLE_KEY,
  STRIPE_CERTN_USA: STRIPE_CERTN_USA_PUBLISHABLE_KEY,
  STRIPE_CERTN_USA_PREPAY: STRIPE_CERTN_USA_PREPAY_PUBLISHABLE_KEY,
  STRIPE_CERTN_UK: STRIPE_CERTN_UK_PUBLISHABLE_KEY,
  STRIPE_CERTN_UK_PREPAY: STRIPE_CERTN_UK_PREPAY_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK: STRIPE_INTERCHECK_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_PREPAY: STRIPE_INTERCHECK_PREPAY_PUBLISHABLE_KEY,
  STRIPE_INTERCHECK_CONSUMER: STRIPE_INTERCHECK_CONSUMER_PUBLISHABLE_KEY,
};
